import { LinkButton } from 'fronton-react';
import React, { useEffect, useRef } from 'react';
import { HorizontalMenuItem } from 'types/model';
import { ItemClassName } from './style';
import { useOptimisedImages } from '@navi-toolbox/hooks';

const ICON_SIZE = 20;

type Props = {
  model: HorizontalMenuItem;
};

export const MenuItem = ({ model }: Props) => {
  return (
    <LinkButton
      className={ItemClassName}
      size="s"
      href={model.url}
      style={{
        color: model.color || undefined,
      }}
    >
      {model.icon ? <Icon src={model.icon} /> : null}
      {model.text}
    </LinkButton>
  );
};

const Icon = (props: { src: string }) => {
  const imageSize = {
    h: `${ICON_SIZE}`,
    w: `${ICON_SIZE}`,
  };
  const ref = useRef<HTMLImageElement>(null);

  const CDNImage = useOptimisedImages({
    src: props.src,
    sizes: {
      restImage: imageSize,
    },
  });

  const onError = () => {
    if (ref.current) {
      ref.current.style.display = 'none';
    }
  };

  useEffect(() => {
    if (ref.current?.complete && ref.current?.naturalHeight === 0) {
      ref.current.style.display = 'none';
    }
  }, []);

  return (
    <img
      src={CDNImage.restImage?.x || ''}
      srcSet={`${CDNImage.restImage?.xx} 2x`}
      ref={ref}
      alt=""
      width={ICON_SIZE}
      height={ICON_SIZE}
      onError={onError}
    />
  );
};
